import { render } from "./Manifesto.vue?vue&type=template&id=af244938&scoped=true"
const script = {}

import "./Manifesto.vue?vue&type=style&index=0&id=af244938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af244938"]])

export default __exports__